module.exports = __webpack_public_path__ + "img/helen-profile.6a415663.jpeg";